import { TenbaggerLogo } from "#/components/ui/logo";

export function PageLoader() {
	return (
		<div className="mx-auto flex min-h-[70vh] max-w-7xl items-center justify-center p-4">
			<div className="motion-safe:animate-bounce [animation-duration:1.2s]">
				<TenbaggerLogo width={60} height={60} />
			</div>
		</div>
	);
}
